import { render, staticRenderFns } from "./WalletSummary.vue?vue&type=template&id=208ccd5e&scoped=true&"
import script from "./WalletSummary.vue?vue&type=script&lang=js&"
export * from "./WalletSummary.vue?vue&type=script&lang=js&"
import style0 from "./WalletSummary.vue?vue&type=style&index=0&id=208ccd5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ccd5e",
  null
  
)

export default component.exports